<script setup lang="ts">
import { DateTime } from 'luxon'

import type { Contact } from '~/layers/forms/models'
import { Address, DocumentTypeEnum, GenderEnum, Person } from '~/layers/forms/models'

interface Props {
  model: Person
  address?: Address
  contact?: Contact
  tag?: string
}

const props = defineProps<Props>()

const data = computed(() => [
  {
    label: 'Correo',
    value: props.contact?.email,
    fullSpan: true,
  },
  { label: 'Teléfono', value: props.contact?.phone, fullSpan: true },
  {
    label: 'Genero',
    value: props.model?.gender ? GenderEnum[props.model?.gender].label : null,
  },
  {
    label: 'Fecha nacimiento',
    value: props.model.birthDate ? DateTime.fromJSDate(props.model.birthDate).toISODate() : null,
  },
  ...(props.model.identification.nationality?.id
    ? [
        {
          label: 'Nacionalidad',
          value: props.model.identification.nationality?.name,
          fullSpan: true,
        },
      ]
    : []),
  {
    label: 'Dirección',
    value: props.address
      ? Object.values(Address.getFullAddress(props.address) ?? {})
          .join(' ')
          .trim()
      : null,
    fullSpan: true,
  },
])
</script>

<template>
  <FormsGlobalResume
    :name="Person.getFullName(model)"
    :data
    :hint-text="tag"
  >
    <template #header>
      <div
        v-if="model.identification.type"
        class="text-sm"
      >
        {{ DocumentTypeEnum[model.identification.type].label }}:
        {{ model.identification.number }}
      </div>

      <slot name="header" />
    </template>
    <template #content>
      <slot name="content" />
    </template>
  </FormsGlobalResume>
</template>
